// removed by extract-text-webpack-plugin
module.exports = {"logo":"PartnershipLogo-logo-fb9957d6"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/PartnershipLogo.scss
// module id = 829
// module chunks = 0